import React from 'react';
import Locale from 'localization/Localization';

export function LegalNotices() {
	return <div className='legal-notices'>
		<p className='legal-notices-text'>{Locale.get('banner_legal_notices')}</p>
	</div>
}

export default LegalNotices;